import { yupResolver } from "@hookform/resolvers/yup";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import Button from "../../Components/Button/Button";
import Input from "../../Components/Input/Input";
import { AuthService } from "../../services/auth.service";
import styles from "./ResetPassword.module.scss";
import { resetPasswordSchema, resetPasswordType } from "./ResetPassword.schema";

const authService = AuthService.getInstance();
const ResetPassword = () => {
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(resetPasswordSchema),
  });

  const forgetPassword = async (data: resetPasswordType) => {
    try {
      await authService.resetPassword(data);
    } catch (error: any) {
      toast.error(error?.message);
    }
  };

  return (
    <div className={styles.forgetPassword}>
      <h2>Reset Password?</h2>
      <form
        onSubmit={handleSubmit(forgetPassword)}
        className={styles.forgetPassword__container}
      >
        <Input
          register={register}
          name="email"
          label={"Email"}
          type="text"
          errorMessage={errors.email?.message}
        />
        <Input
          register={register}
          name="otp"
          label={"OTP"}
          type="text"
          errorMessage={errors.otp?.message}
        />
        <Input
          register={register}
          name="password"
          label={"Password"}
          type="password"
          errorMessage={errors.password?.message}
        />

        <Button label="Reset" type="submit" fullWidth={true} />
      </form>
    </div>
  );
};
export default ResetPassword;
